// SessionExpiredModal.jsx - Version corrigée sans react-oauth2-code-pkce
import React from 'react';
//import { useAuth } from '../contexts/AuthContext';
import { useAuth } from '../hooks/useAuth';
export const SessionExpiredModal = ({ isIdle, onReconnect }) => {
  const { logout } = useAuth();
  
  if (!isIdle) return null;

  const handleReconnect = async () => {
    if (onReconnect) {
      await onReconnect();
    } else {
      // Fallback: nettoyer et rediriger
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      logout();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-xl font-bold mb-4 text-red-600">Session inactive</h2>
        <div className="flex justify-center mb-4">
          <img src="/images/logoiss.png" alt="ISS Logo" className="max-w-full max-h-24 object-contain" />
        </div>
        <p className="mb-4 text-gray-700">
          Votre session est inactive depuis 5 minutes.
          {onReconnect ? (
            " Cliquez sur 'Reprendre' pour continuer votre session."
          ) : (
            " Veuillez vous reconnecter pour continuer."
          )}
        </p>
        <button
          onClick={handleReconnect}
          className="w-full bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700 transition focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          {onReconnect ? "Reprendre la session" : "Se reconnecter"}
        </button>
      </div>
    </div>
  );
};